<template>
  <div>
    <Card>
      <ui-switcher v-model="value"></ui-switcher>
    </Card>
    <Card>
      <ui-switcher :disabled="true" v-model="value"></ui-switcher>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';

const value = ref(true);
</script>
